import { observable, action } from "mobx";
import StripeConnect from "~/models/StripeConnect";
import StripeConnectRepository from "~/repository/StripeConnectRepository";

class StripeConnectStore {
  @observable isLoading = false;

  @observable stripeConnect = null;

  stripeConnectRepository = null;

  constructor() {
    this.stripeConnectRepository = new StripeConnectRepository();
  }

  @action
  load(customerId) {
    this.isLoading = true;

    return this.stripeConnectRepository.fetchCustomer(customerId).then(response => {
      const { data } = response;
      this.stripeConnect = new StripeConnect(data);
      this.isLoading = false;
    });
  }
}

export default StripeConnectStore;
